
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/tools/anchor-text-generator",
      function () {
        return require("private-next-pages/app/tools/anchor-text-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/tools/anchor-text-generator"])
      });
    }
  